import { FC } from 'react';
import styled from 'styled-components';

import ClickableButton from '@/components/Buttons/ClickableButton';
import { getImage } from '@/lib/fetchAPI';

const EmptyState: FC<any> = ({ data }) => (
	<Empty>
		<Image loading="lazy" alt="I can't even" src={getImage(data?.image)} />

		<Text>{data?.text}</Text>

		<ButtonWrapper>
			<ClickableButton
				width="empty"
				text={data?.cta?.text}
				href="https://share.hsforms.com/12dJLE_P8S9SFBitFV8l1Fw4fpwx" // TODO: check if the link is valid
			/>
		</ButtonWrapper>
	</Empty>
);

const Empty = styled.div`
	text-align: center;
	margin-top: 18vh;
	margin-bottom: 24vh;
`;

const Image = styled.img`
	max-width: 220px;
	display: block;
	margin: 0 auto;
	margin-bottom: 15px;
`;

const Text = styled.h4`
	font-family: var(--font-sans);

	font-size: 19px;
	line-height: 25px;
	color: var(--color-purple-50);
`;

const ButtonWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 32px;
`;

export default EmptyState;
